import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1838.86029,1451.57632 L1920,1532.94589 L1558.4341,1894.51179 L361.565904,1894.51179 L0,1532.94589 L81.2546391,1451.57632 L409.146414,1779.58302 L1510.85359,1779.58302 L1838.86029,1451.57632 Z M962.333054,25 L1462.61798,525.284928 L1381.47827,606.654495 L1019.68251,244.973662 L1019.68251,1432.53262 L904.86867,1432.53262 L904.86867,244.973662 L543.187837,606.654495 L462.048126,525.284928 L962.333054,25 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconUploadLine = /*#__PURE__*/function (_Component) {
  _inherits(IconUploadLine, _Component);

  var _super = _createSuper(IconUploadLine);

  function IconUploadLine() {
    _classCallCheck(this, IconUploadLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconUploadLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconUpload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconUploadLine.displayName = "IconUploadLine";
  return IconUploadLine;
}(Component);

IconUploadLine.glyphName = 'upload';
IconUploadLine.variant = 'Line';
IconUploadLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconUploadLine;
export { IconUploadLine };